import { render, staticRenderFns } from "./ClassicSubtabBar.vue?vue&type=template&id=b242ebf6&scoped=true"
import script from "./ClassicSubtabBar.vue?vue&type=script&lang=js"
export * from "./ClassicSubtabBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b242ebf6",
  null
  
)

export default component.exports